import { FC } from 'react';

import { ButtonProps, ButtonVariant } from '@/shared/ui/Button';
import { Button } from '@/shared/ui/Button/Button';
import { Icon } from '@/shared/ui/Icon/Icon';

export const DonwloadContractButton: FC<ButtonProps> = (props) => {
  return (
    <Button variant={ButtonVariant.GHOST} {...props}>
      <Icon name="download" />
      Договір страхування
    </Button>
  );
};
